import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { COLORS, SURFACES } from '~styles/tokens';

const BREAKPOINTS = {
  mobile: '768px',
  tablet: '1024px',
} as const;

export const Background = styled.header`
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  box-shadow: 0px 3px 6px #00000029;
  padding: 0 2.5rem 0 1.5rem;
  position: sticky;
  top: 0;
  z-index: 40;

  @media (max-width: ${BREAKPOINTS.mobile}) {
    padding: 0 1rem;
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  height: 3.5rem;
  width: 100%;
  max-width: 1412px;
  margin: 0 auto;

  > a {
    display: flex;
    align-items: center;
    flex-shrink: 0;

    &:focus-visible {
      outline: 2px solid ${COLORS.primary};
      outline-offset: 2px;
      border-radius: 4px;
    }
  }

  > svg {
    color: ${COLORS.danger};
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    gap: 0.5rem;
  }
`;

export const BreadCrumb = styled.nav`
  display: flex;
  align-items: center;
  font-family: "Roboto";
  font-size: 0.875rem;
  color: ${COLORS.textTertiary};
  flex-shrink: 1;
  min-width: 0;
  overflow: hidden;

  @media (max-width: ${BREAKPOINTS.mobile}) {
    display: none;
  }
`;

export const BreadcrumbLink = styled(Link)`
  color: ${COLORS.textTertiary};
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.2s;

  &:hover {
    color: ${COLORS.primary};
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.primary};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const BreadcrumbSeparator = styled.span`
  color: ${COLORS.textMuted};
  margin: 0 0.5rem;
`;

export const BreadcrumbCurrent = styled.span`
  color: ${COLORS.primary};
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SearchButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-left: auto;
  padding: 0.5rem 1rem;
  background-color: ${SURFACES.alternative};
  border: 1px solid ${COLORS.borderDefault};
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.2s;
  color: ${COLORS.textTertiary};
  font-size: 0.875rem;
  min-width: 600px;

  &:hover {
    background-color: ${COLORS.neutral200};
    border-color: ${COLORS.borderStrong};
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.primary};
    outline-offset: 2px;
  }

  span {
    flex: 1;
    text-align: left;
  }

  @media (max-width: ${BREAKPOINTS.tablet}) {
    min-width: auto;
    padding: 0.5rem;

    span {
      display: none;
    }
  }
`;

export const Kbd = styled.kbd`
  display: inline-flex;
  align-items: center;
  padding: 0.125rem 0.375rem;
  font-family: inherit;
  font-size: 0.6875rem;
  background: ${SURFACES.card};
  border: 1px solid ${COLORS.borderStrong};
  border-radius: 4px;
  color: ${COLORS.textMuted};

  @media (max-width: ${BREAKPOINTS.tablet}) {
    display: none;
  }
`;

export const Profile = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: transparent;
  border: none;
  padding: 0.25rem 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${SURFACES.alternative};
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.primary};
    outline-offset: 2px;
  }

  img {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    object-fit: cover;
    background-color: ${COLORS.neutral100};
  }

  p {
    font-size: 0.875rem;
    color: ${COLORS.textPrimary};
    white-space: nowrap;

    @media (max-width: ${BREAKPOINTS.mobile}) {
      display: none;
    }
  }
`;

export const Separator = styled.div`
  width: 1px;
  background-color: ${COLORS.borderDefault};
  height: 1.5rem;
  flex-shrink: 0;
`;

export const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  background: transparent;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  color: ${COLORS.textTertiary};
  transition: all 0.2s;
  flex-shrink: 0;

  svg {
    width: 1.25rem;
    height: 1.25rem;
  }

  &:hover {
    background-color: ${COLORS.dangerLight};
    color: ${COLORS.dangerHover};
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.primary};
    outline-offset: 2px;
  }
`;
